import React from "react";
import RegisterForShares from "./RegisterForShares";

const SignUpForG6 = () => {
  return <RegisterForShares />;
};

export default SignUpForG6;
